import React, { useEffect } from 'react';
import { Box, FlexControlledForm, useDebounceState } from '@common-fe/common-fe';

import { GeneralInfoPayload, useStore } from '@/modules/employee/Employee/PersonalInformation/GeneralInfo/stores/useGeneralInfo.store';

import useCommunicationChannelsFields from './hook/useCommunicationChannelsFields';

interface Props {
  isEditMode?: boolean;
  isShowErrors?: boolean;
}

const CommunicationChannels: React.FC<Props> = ({ isEditMode, isShowErrors }) => {
  const handleSetState = useStore((state) => state.setState);
  const { setValues, values } = useDebounceState<Partial<GeneralInfoPayload>>();

  const fields = useCommunicationChannelsFields({ isEditMode });

  useEffect(() => {
    if (values) {
      delete values.employeeEmailPrefer;
      delete values.employerEmailPrefer;
      handleSetState(values);
    }
  }, [handleSetState, values]);

  return (
    <Box background="canvas" round="container1Round">
      <FlexControlledForm
        testId="communication-channels"
        key={`communication-channels_${isEditMode}`}
        formTitle="Communication Channels"
        fields={fields}
        showError={isShowErrors}
        editMode={isEditMode}
        isDisabledMode={isEditMode}
        onChangeValues={setValues}
        isThinMode
      />
    </Box>
  );
};

export default CommunicationChannels;
